import { useContext } from 'react';

import { TutorialContext, type TutorialContextValue } from '@/components/tutorial/tutorial-provider';

/** Hors `TutorialProvider`, seul `isActive` (faux) est fourni. */
export const useTutorial = (): Partial<TutorialContextValue> & { isActive: boolean } => {
  const context = useContext(TutorialContext);
  if (!context) {
    return { isActive: false };
  }
  return context;
};
